(() => {
  if (window.tgbBulkInquiryLoaded) return;
  window.tgbBulkInquiryLoaded = true;
  const dialog = document.getElementById('TgbBulkDialog');
  const form = document.getElementById('TgbBulkContact');
  if (!form) return;
  let trigger;
  let previousOverflow = '';
  const parameters = new URLSearchParams(window.location.search);
  const returnField = form.querySelector('[name="return_to"]');
  if (returnField) {
    const returnUrl = new URL(window.location.href);
    returnUrl.searchParams.delete('contact_posted');
    returnUrl.hash = 'TgbBulkContact';
    returnField.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
  }
  const date = form.querySelector('#BulkDate');
  if (date) {
    const today = new Date();
    date.min = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('-');
  }
  const variant = form.querySelector('[data-bulk-variant]');
  const productUrl = form.querySelector('[data-bulk-product-url]');
  const updateVariant = () => {
    if (!variant) return;
    const current = document.querySelector('product-info form[action*="/cart/add"] [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
    const value = current?.value || parameters.get('variant') || variant.value;
    if (/^\d+$/.test(value)) {
      variant.value = value;
      const url = new URL(productUrl.value, window.location.origin);
      url.searchParams.set('variant', value);
      productUrl.value = url.href;
    }
  };
  const open = (element) => {
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    trigger = element;
    updateVariant();
    if (!dialog.open) {
      previousOverflow = document.body.style.overflow;
      dialog.showModal();
      document.body.style.overflow = 'hidden';
    }
    (form.querySelector('[data-bulk-success], [data-bulk-errors]') || form.querySelector('#BulkQuantity'))?.focus();
    return true;
  };
  if (dialog) {
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-tgb-bulk-open]');
      if (link && !event.ctrlKey && !event.metaKey && !event.shiftKey && open(link)) event.preventDefault();
    });
    dialog.querySelector('[data-bulk-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      trigger?.focus();
    });
    if (form.querySelector('[data-bulk-success], [data-bulk-errors]')) open(null);
  } else {
    const gift = form.querySelector('#BulkGift');
    if (gift && parameters.has('gift')) gift.value = parameters.get('gift').slice(0, 300);
    const path = parameters.get('product');
    if (path && productUrl) {
      const url = new URL(path, window.location.origin);
      if (url.origin === window.location.origin && url.pathname.startsWith('/products/')) productUrl.value = url.origin + url.pathname;
    }
  }
  form.addEventListener('submit', (event) => {
    const quantity = form.querySelector('#BulkQuantity');
    if (quantity && (!Number.isInteger(Number(quantity.value)) || Number(quantity.value) < 5)) {
      event.preventDefault();
      quantity.reportValidity();
      return;
    }
    updateVariant();
  });
})();
